import { ofType } from "redux-observable";
import { EMPTY, from } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { selectGrantRewardsInfo } from "../../../selectors/selectGrantRewardsInfo";
import { utilGrantRewards } from "../../../utils/utilGrantRewards";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { TypeGrantRewards } from "../../grant-rewards/TypeGrantRewards";
import { actionInventoryInfoAddResource } from "../../info/inventory/actionInventoryInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionFortuneTellerEventInfo } from "../actionFortuneTellerEventInfo";
export var epicFortuneTellerCollectReward = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionFortuneTellerEventInfo.Collect), filter(function () { return state$.value.grantRewards.rewardsType === TypeGrantRewards.FortuneTeller; }), switchMap(function () {
        var grantRewards = selectGrantRewardsInfo(state$.value);
        if (grantRewards) {
            var resourceRewards = grantRewards.resourceRewards;
            var uniqueAnimationId = utilGrantRewards.getUniqueAnimationId(grantRewards);
            var rewards = utilGrantRewards.getResourcesRewards(grantRewards);
            return from([
                actionModalClose(IdModal.CollectReward),
                actionInventoryInfoAddResource(resourceRewards),
                actionAddPelletsInScreenCenterAnimation(uniqueAnimationId, rewards),
            ]);
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/epics/epicFortuneTellerCollectReward.ts
// module id = 1855
// module chunks = 3